(function ($) {

    let modal_add_address = '';

    if($('#modal-add-user-adress').length > 0) {
        modal_add_address = new bootstrap.Modal('#modal-add-user-adress');
    }

    $(document).on('click', '#save_account_details', function (e) {
        e.preventDefault();

        let errorInput,
            button = $(this),
            form = button.closest('form.edit-password')

        if (form.length === 0) {
            return false;
        }

        const passwordCurrentInput = form.find('input[name=password_current]'),
            passwordNewInput = form.find('input[name=password_1]'),
            passwordConfirmInput = form.find('input[name=password_2]')

        let passwordCurrent = passwordCurrentInput.val(),
            passwordNew = passwordNewInput.val(),
            passwordConfirm = passwordConfirmInput.val()

        if (!passwordCurrent) {
            showError(passwordCurrentInput, 'No or wrong password entered.')
            return false
        }

        if(passwordNew !== passwordConfirm) {
            showError(passwordNewInput, 'Passwords do not match.')
            return false
        }


        let data = {
            action: 'woocommerce_ajax_edit_password',
            passwordCurrent: passwordCurrent,
            passwordNew: passwordNew,
            passwordConfirm: passwordConfirm,
        };

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            success: function (response) {
                if (response.success) {
                    $('#js-message').text(response.messages.success_message);
                } else {
                    for (const [error, message] of Object.entries(response.messages)) {
                        if (error === 'current_password_error_message') errorInput = passwordCurrentInput
                        if (error === 'password_error') errorInput = passwordCurrentInput
                        if (error === 'update_password_error_message') errorInput = passwordNewInput
                        if (errorInput) showError(errorInput, message)
                    }
                }
            },
        });

        return false;
    });

    $('#submit-editor-profile').on('click', function (e){
        e.preventDefault();

        edit_user_fields($(this));
    });


    $(document).on('click', '#add_user_adress', function (e) {
        modal_add_address.show();
    });

    $(document).on('click', '#save_adress', function (e) {
        save_additional_address($(this))
    });
})(jQuery);

function edit_user_fields(button) {
    let form = $('#js-edit-account'),
    account_details = {}

    $('#js-edit-account input').each(function() {
        account_details[$(this).attr("name")] = $(this).val();
    })

    let emailInput = $('#account_email')

    if (emailInput.length > 0 && !validateEmail(account_details.account_email)) {
        emailInput.after('<div class="js-edit-message" style="color:red;">No or wrong e-mail address entered.</div>');
        return false
    }

    let data = {
        action: 'ajax_edit_user_fields',
        account_details:account_details,
    };

    $.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        data,
        beforeSend: function () {
            // add loader
            form.append('<div class="form__loader"><i class="icon-load"></i></div>');
        },
        success: function (response) {
            // remove loader
            $(form).find('.form__loader').remove();

            if (response.success) {
                form.after('<div class="js-edit-message" style="color:green;">'+ response.message +'</div>');
            } else {
                form.after('<div class="js-edit-message" style="color:red;">'+ response.message +'</div>');
            }

            setTimeout(function () {
                $('.js-edit-message').remove()
            }, 3000)

        },
    });
}

function save_additional_address(button) {
    let data = {}
    let inputs = button.closest('.modal-content__body').find('input, select')
    inputs.each(function() {
        if($(this).val().length === 0) {
            showError($(this), 'Fill this field!')
            return
        }
        data[$(this).attr('name')] = $(this).val();
    })

    $.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        method: 'POST',
        data: {
            action: 'save_user_shipping_address',
            data:data
        },
        success: function (response) {
            if (response.success) {
                input.append(response.message);
            } else {
                return false;
            }
        },
    });
}

$('#billing_country').on('change', function() {
    getState(this.value, '#billing_state')
});

$('#shipping_country').on('change', function() {
    getState(this.value, '#shipping_state')
});

$('#address_country').on('change', function() {
    getState(this.value, '#address_state')
});

function getState(country, selector) {
    $.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        method: 'POST',
        data: {
            action: 'get_state_options',
            country:country
        },
        success: function (response) {
            $(selector).html('')
            if(response.success) {
                $(selector).append(response.state_options)
            }
        },
    });
}